import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import { PiaggioCustomers } from "./types";
import {
  ADD_UPDATE_PIAGGIO_CUSTOMER_REQUEST,
  FETCH_PIAGGIO_CUSTOMER_LIST_REQUEST,
} from "./actionTypes";
import {
  addUpdatePiaggioCustomerFailure,
  addUpdatePiaggioCustomerSuccess,
  fetchPiaggioCustomerListFailure,
  fetchPiaggioCustomerListSuccess,
} from "./actions";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchPiaggioCustomerListSaga(action: any) {
  try {
    const response: PiaggioCustomers[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount =
      response && response.length > 0 && response[0]?.totalCount
        ? response[0].totalCount
        : 0;
    yield put(fetchPiaggioCustomerListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchPiaggioCustomerListFailure(errorMessage));
  }
}

function* addUpdatePiaggioCustomerSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdatePiaggioCustomerSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdatePiaggioCustomerFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* piaggioSaga() {
  yield takeLatest(
    FETCH_PIAGGIO_CUSTOMER_LIST_REQUEST,
    fetchPiaggioCustomerListSaga
  );
  yield takeLatest(
    ADD_UPDATE_PIAGGIO_CUSTOMER_REQUEST,
    addUpdatePiaggioCustomerSaga
  );
}
